export default __webpack_public_path__ + "static/hiv-care-continuum-df3718f14d550aaaa8790f3ffee8063c.svg";